export default {
  //Discard partially raised Issues dialog text
  discard_raised_issues_title: "Discard partially raised Issues",
  discard_raised_issues_content_1:
    "One or more of the <b class='text-info'>Performed Work</b> has related unsubmitted <b class='text-info'>Issues</b> you have set to be raised.",
  discard_raised_issues_content_2:
    "<b class='text-negative'>Discarding the unsubmitted Performed Work will also remove the unsubmitted Issues!</b>",
  discard_raised_issues_content_3: "Are you sure you want to do this?",
}
